(function () {

    function toggleWishlist(e) {

        const btn = e.target.closest('.ww-wishlist-btn');

        if (!btn) return;

        e.preventDefault();
        e.stopImmediatePropagation();

        btn.classList.toggle('is-active');

        console.log('Wishlist Clicked', btn.className);

    }

    document.addEventListener('click', toggleWishlist, true);

})();